//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<template>
  <div class='content-wrapper'  style="height2:600px; overflow-y2:scroll;">
    <Button type="ghost" style="border-radius:3px; margin-bottom:10px;" @click="newTaskOnClick">Создать новую задачу</Button>

    <!-- здесь еще надо сделать левую панель-список 'Куча на рассмотрение' и чтобы список был поумолчанию свернут но можно было развернуть направо-->
    <!-- и такую же правую панель-список 'Давно завершенные' и чтобы список был поумолчанию свернут но можно было развернуть налево-->

    <Row>
      <Col span="8" style="padding-right:20px;">
        <div style="padding-bottom:5px;">Открытые</div>
        <draggable element="span" v-model="theBoardTasks" :options="dragOptions" :move="onMove" @start="isDragging=false" @end="isDragging=false">
          <transition-group type2="transition" name="flip-list" class="list-group" tag="ul">
            <li class="list-group-item" v-for="element in theBoardTasks" :key="element.val.id" :style="{height: getTaskHeight(element)}">
              <i :class="element.fixed? 'fa fa-anchor' : 'glyphicon glyphicon-pushpin'" @click=" element.fixed=! element.fixed" aria-hidden="true"></i>
              <span style="float:left">{{element.val.name}}</span>
              <span v-on:click="editTaskOnClick(element)" style="float:right">
                <Icon type="more" class="task-edit-icon"></Icon>
              </span>
              <span class="badge" style="float:right">{{element.val.id}}</span>
              <br>
              <div v-for="(checklistItem, indx) in element.val.body.checklist" :key="indx" style="width:100%; font-size:12px; margin-left:30px; margin-bottom:3px; float:left">
                {{checklistItem}}
              </div>
              <draggable element="span" v-model="element.subtasks" :options="dragOptions" :move="onMove" @start="isDragging=true" @end="isDragging=false">
                <transition-group type2="transition" name="flip-list" class="list-group2" tag="ul">
                  <li class="list-group2-item" v-for="element in element.subtasks" :key="element.val.id" :style="{height: getTaskHeight(element)}">
                    <i :class="element.fixed? 'fa fa-anchor' : 'glyphicon glyphicon-pushpin'" @click=" element.fixed=! element.fixed" aria-hidden="true"></i>
                    <span style="float:left">{{element.val.name}}</span>
                    <span v-on:click="editTaskOnClick(element)" style="float:right">
                      <Icon type="more" class="task-edit-icon"></Icon>
                    </span>
                    <span class="badge" style="float:right">{{element.val.id}}</span>
                    <br>
                    <div v-for="(checklistItem, indx) in element.val.body.checklist" :key="indx" style="width:100%; font-size:12px; margin-left:30px; margin-bottom:3px; float:left">
                      {{checklistItem}}
                    </div>
                  </li>
                </transition-group>
              </draggable>
            </li>
          </transition-group>
        </draggable>
      </Col>
      <Col span="8" style="padding-right:20px;">
        <div style="padding-bottom:5px;">В работе</div>
        <draggable element="span" v-model="list2" :options="dragOptions" :move="onMove" @start="isDragging=true" @end="onEnd">
            <transition-group type2="transition" name="flip-list" class="list-group" tag="ul">
              <li class="list-group-item" v-for="element in list2" :key="element.val.id" :style="{height: getTaskHeight(element)}">
                <i :class="element.fixed? 'fa fa-anchor' : 'glyphicon glyphicon-pushpin'" @click=" element.fixed=! element.fixed" aria-hidden="true"></i>
                {{element.val.name}}
                <span class="badge">{{element.val.id}}</span>
                <br>
                <div v-for="(checklistItem, indx) in element.val.body.checklist" :key="indx" style="width:100%; font-size:12px; margin-left:30px; margin-bottom:3px; float:left">
                  {{checklistItem}}
                </div>
              </li>
            </transition-group>
        </draggable>
      </Col>
      <Col span="8" style="padding-right:20px;">
        <div style="padding-bottom:5px;">Завершенные</div>
        <draggable element="span" v-model="list3" :options="dragOptions" :move="onMove" @start="isDragging=true" @end="isDragging=false">
            <transition-group type2="transition" name="flip-list" class="list-group" tag="ul">
              <li class="list-group-item" v-for="element in list3" :key="element.val.id" :style="{height: getTaskHeight(element)}">
                <i :class="element.fixed? 'fa fa-anchor' : 'glyphicon glyphicon-pushpin'" @click=" element.fixed=! element.fixed" aria-hidden="true"></i>
                {{element.val.name}}
                <span class="badge">{{element.val.id}}</span>
                <br>
                <div v-for="(checklistItem, indx) in element.val.body.checklist" :key="indx" style="width:100%; font-size:12px; margin-left:30px; margin-bottom:3px; float:left">
                  {{checklistItem}}
                </div>
              </li>
            </transition-group>
        </draggable>
      </Col>
    </Row>

    <!--div v-for="(item, key) in theBoardTasks" :key="key">
      <div class="task-title" style="clear:left">
        <div v-if="item.val.body22222 != null" style="padding-right:4px; background:#fff; float:left" v-on:click="changeCheckedOnClick(item)">
          <Icon v-if="item.val.body.done == true" type="checkmark-round" style="font-size:13px; margin-right:0px; color:#999"></Icon>
          <Icon v-else type="android-checkbox-outline-blank" style="font-size:14px; margin-right:0px; color:#999"></Icon>
        </div>
        <div v-else style="padding:0px; background:#fff; float:left">
          <div style="font-family:'Tahoma'; font-size:20px; margin-top:-0px; padding-left:1px; padding-right:14px; background:#fff; width:10px; float:left">&middot;</div>
        </div>
        <div style="float:left" :class="{'text-line-through':(item.val.body2222 != null) && (item.val.body.done == true)}" v-on:dblclick="quickEditNameMode(item)">
          {{item.val.name}}
        </div>
        {{item.quickEditNameMode}}
        <div v-if="item.quickEditNameMode == true" style="float:left">
          &nbsp;<Icon type="compose"></Icon>
        </div>
        <div v-on:click="editTaskOnClick(item)" style="float:left">
          <Icon type="edit" class="task-edit-icon"></Icon>
        </div>
      </div>
    </div-->

  </div>
</template>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<script>
// import Vue from 'vue'

import { mapGetters, mapMutations } from 'vuex'

// help - https://github.com/SortableJS/Vue.Draggable
// options - https://github.com/RubaXa/Sortable#options
// базовый Sortablejs - http://rubaxa.github.io/Sortable/
import draggable from 'vuedraggable'

// import http from 'axios'
// import serverData from '@/store/serverData'

import restResource from '@/technical/restResource'
import serverErrorHandling from '@/technical/serverErrorHandling'

const message = [ 'vue.draggable', 'draggable', 'component', 'for', 'vue.js 2.0', 'based', 'on', 'Sortablejs' ]
const messageParents = [ 'Tolik', 'Krolik', 'Krolik', 'Tolik', 'Tolik', 'Tolik', 'Krolik', 'Tolik' ]
const checklist1 = [ 'base', 'second', 'fhjksfhkj', 'dsfsdf354' ]
const checklist2 = [ 'lalala', 'tratata', 'something', 'wowwow', 'lalala', 'tratata', 'something', 'wowwow' ]

export default {
  props: ['board'],
  components: { draggable },
  data () {
    return {
      theBoardTasks: [],
      list11111: message.map((name, index) => {
        let checklist = null
        if (index === 2) checklist = checklist1
        if (index === 5) checklist = checklist2
        return {name, order: index + 1, fixed: false, parent: messageParents[index], checklist: checklist}
      }),
      list2: [],
      list3: [],
      editable: true,
      isDragging: false,
      delayedDragging: false
    }
  },
  computed: {
    ...mapGetters([
      'commonData',
      'activeUser',
      'appSettings'
    ]),
    theBoardTasks2: function () {
      // let retTasks = {}
      // for (var i in this.commonData.tasks) {
      //   let item = this.commonData.tasks[i]
      //   if (item.val.belongsToBoard === this.board.id) {
      //     retTasks[item.val.id] = item
      //   }
      // }
      let retTasks = []
      for (var i in this.commonData.tasks) {
        let item = this.commonData.tasks[i]
        let checklist = null
        if (this.commonData.tasks[i].val.id === 7) checklist = checklist1
        if (this.commonData.tasks[i].val.id === 10) checklist = checklist2
        item.val.body.checklist = checklist
        if (item.val.belongsToBoard === this.board.id) {
          retTasks.push(item)
        }
      }
      return retTasks
      // return this.commonData.tasks.filter(function (task) {
      //   return task.belongsToBoard === this.board.id
      // })
    },
    dragOptions () {
      return {
        animation: 100,
        group: 'tasks',
        scroll: true,
        disabled: false,
        ghostClass: 'ghost'
      }
    }
  },
  created: function () {
    let retTasks = []
    for (var i in this.commonData.tasks) {
      let item = this.commonData.tasks[i]
      item.subtasks = []
      if (this.commonData.tasks[i].val.id === 6) {
        item.subtasks.push({val: {name: 'SUBTASK!!!!!!!!', id: 100, body: {}}})
      }
      let checklist = null
      if (this.commonData.tasks[i].val.id === 7) checklist = checklist1
      if (this.commonData.tasks[i].val.id === 10) checklist = checklist2
      item.val.body.checklist = checklist
      if (item.val.belongsToBoard === this.board.id) {
        retTasks.push(item)
      }
    }
    this.theBoardTasks = retTasks
  },
  watch: {
    'commonData.tasks': function (newVal, oldVal) {
      let retTasks = []
      for (var i in this.commonData.tasks) {
        let item = this.commonData.tasks[i]
        item.subtasks = []
        if (this.commonData.tasks[i].val.id === 6) {
          item.subtasks.push({val: {name: 'SUBTASK!!!!!!!!', id: 100, body: {}}})
        }
        let checklist = null
        if (this.commonData.tasks[i].val.id === 7) checklist = checklist1
        if (this.commonData.tasks[i].val.id === 10) checklist = checklist2
        item.val.body.checklist = checklist
        if (item.val.belongsToBoard === this.board.id) {
          retTasks.push(item)
        }
      }
      this.theBoardTasks = retTasks
    },
    isDragging (newValue) {
      // if (newValue) {
      //   this.delayedDragging = true
      //   return
      // }
      // this.$nextTick(() => {
      //   this.delayedDragging = false
      // })
    }
  },
  methods: {
    getTaskHeight (task) {
      if (task.val.body.checklist == null) return '70px' // '40px'
      return (10 + 15 + task.val.body.checklist.length * 15 + 10).toString() + 'px'
    },
    onMove ({relatedContext, draggedContext}) {
      // const relatedElement = relatedContext.element
      const draggedElement = draggedContext.element
      // return (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
      // return ((relatedElement.val.id !== 24) && (draggedElement.val.id !== 24))
      return (draggedElement.val.id !== 6)
    },
    onEnd (evt) {
      console.log(evt)
      this.isDragging = false
    },
    ...mapMutations([
      'commonDataTasksAdd',
      'commonDataTaskValSet',
      'commonDataTaskForEditSet',
      'commonDataTaskPropertySet'
    ]),
    newTaskOnClick () {
      // console.log(this.list)
      // console.log(this.theBoardTasks)
      // return
      let thisRef = this
      let newTask = restResource(this.appSettings.server.host + this.appSettings.server.taskResource)
      newTask.val = {
        name: '[Без названия]',
        belongsToBoard: this.board.id,
        body: {done: false}
      }
      newTask.save()
      .then(function (response) {
        newTask.val = response.data
        // thisRef.$message.success('Запись сохранена на сервер')
        thisRef.commonDataTasksAdd(newTask)
        thisRef.commonDataTaskForEditSet(newTask)
        thisRef.$router.push('/tasks/taskEdit')
      })
      .catch((error) => serverErrorHandling(error, thisRef))
    },
    quickEditNameMode (task) {
      this.commonDataTaskPropertySet({id: task.val.id, prop: 'quickEditNameMode', value: task.quickEditNameMode == null ? true : !task.quickEditNameMode})
    },
    editTaskOnClick (task) {
      this.commonDataTaskForEditSet(task)
      this.$router.push('/tasks/taskEdit')
      // this.$nextTick(() => console.log(this.$parent.$parent.$parent.$parent.$children[1].$refs)) // это сложный путь и тут еще надо просматривать children ведь их последовательность программисты могут поменять
      // this.$nextTick(() => this.$parent.$parent.$parent.$parent.$children[1].$refs.taskname.$el.children[1].focus()) // это сложный путь и тут еще надо просматривать children ведь их последовательность программисты могут поменять
    },
    changeCheckedOnClick (task) {
      let thisRef = this
      let value = true
      if (task.val.body.done != null) {
        value = !task.val.body.done
      }
      this.commonDataTaskPropertySet({id: task.val.id, prop: 'val.body.done', value: value})

      this.commonData.tasks[task.val.id].save()
      .then(function (response) {
        thisRef.commonDataTaskValSet(response.data)
      })
      .catch((error) => serverErrorHandling(error, thisRef))
    }
  }
}
</script>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<style>
.ivu-checkbox+span, .ivu-checkbox-wrapper+span {
  margin-right: 0px;
}
.ivu-checkbox-checked .ivu-checkbox-inner {
  background-color: #c0c2d2;
  border: solid 1px #c0c2d2;
}
</style>

<style scoped>
.content-wrapper{
  margin: 0px 0px 0px 0px; /* margin: 25px 20px 50px 20px; */
  padding: 0px;
  background: #fff;
  /*height: calc(100% - 50px); /* если цвет отличный от стандартной серой подложики для content или убираем серые margins, то чтобы серый прикрыть надо height=100% */*/
  font-family: "Roboto Light", sans-serif;
  font-size: 15px;
  /*overflow: auto;*/
}
.task-title {
  padding-bottom: 3px;
}
.task-title:hover{
  cursor: pointer;
}
.task-edit-icon {
  font-size: 13px;
  color: #777;
  padding-left: 5px;
  padding-top: 3px;
}
.task-edit-icon:hover,  .task-title:hover .task-edit-icon{
  color: #ddd;
  cursor: pointer;
}
.text-line-through {
  text-decoration: line-through;
}


.flip-list-move {
  transition: transform 0.5s;
}
.no-move {
  transition: transform 0s;
}
.ghost {
  opacity: .5;
  background: #C8EBFB;
}
.list-group {
  min-height: 20px;
  background: #99ff99;
}
.list-group-item {
  cursor: move;
  background: #fff;
}
.list-group2 {
  min-height: 50px;
  background: #ffff99;
}
.list-group2-item {
  cursor: move;
  /*background: #9999ff;*/
}
.list-group-item i {
  cursor: pointer;
}
</style>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////



// WEBPACK FOOTER //
// TaskBoard.vue?4a4369b6